import Vue from 'vue'
import Vuex from 'vuex'

import lang from './lang.js'
import user from './user.js'
Vue.use(Vuex)

//实例store对象
const store = new Vuex.Store({
	
	//state 是定义存储数据的地方， 必须存在
	state: {},
	
    //mutations是修改store数据入口
	mutations: {},
	
	//getters获取state属性
	getters:{},
	
	//actions是修改store数据入口，不同点是可以异步
	actions:{},
	
	//模块化store，防止代码臃肿
	modules:{
		lang,
		user,
	}
})
 
//导出store对象
export default store